import type { getUploadedFileRecordSchema } from '@shared-schemas/origin-destination'
import type * as v from 'valibot'

namespace OriginDestination {
	/**
	 * Enums
	 */
	export namespace Enums {
		export enum JobStatus {
			WAITING = 'waiting',
			RUNNING = 'running',
			ENDED = 'ended',
			FAILED = 'failed',
			CANCELED = 'canceled',
			ACCEPTED = 'accepted',
			REJECTED = 'rejected',
		}

		export enum UploadedFileFormat {
			GEOJSON = 'geojson',
			SHAPEFILE = 'shapefile',
		}

		export enum UploadedFileUploadStatus {
			PENDING = 'pending',
			UPLOADING = 'uploading',
			CANCELED = 'canceled',
			FAILED = 'failed',
			SUCCESSFUL = 'successful',
		}

		export enum UploadedFileValidationStatus {
			PENDING = 'pending',
			VALIDATING = 'validating',
			FAILED = 'failed',
			SUCCESSFUL = 'successful',
		}

		export enum HistogramType {
			HOURS_OF_DAY = 'HOURS_OF_DAY',
			LENGTHS = 'LENGTHS',
			DURATIONS = 'DURATIONS',
			AVG_SPEEDS = 'AVG_SPEEDS',
		}
	}
}

export default OriginDestination

export type UploadedFileRecord = v.InferOutput<ReturnType<typeof getUploadedFileRecordSchema>>
